export default __webpack_public_path__ + "ab0f130fa454fb923fb99e7e954fc066.svg";